import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'mycompanies',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'myCompaniesList',
      component: () => import('@/views/mycompanies/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support'],
      },
    },
    {
      path: ':companyId/users',
      name: 'myCompanyUsers',
      component: () => import('@/views/mycompanies/users/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support'],
      },
    },
    {
      path: ':companyId/users/:userId/transaction',
      name: 'myCompanyUserTransactions',
      component: () => import('@/views/mycompanies/users/transactions/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support'],
      },
    },
    {
      path: ':companyId/users/:userId/transaction/:transactionId/metadata',
      name: 'myCompanyUserTransactionMetadatas',
      component: () => import('@/views/mycompanies/users/transactions/metadata/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support'],
      },
    },

    {
      path: ':companyId/users/:userId/transaction/:transactionId/metadata/:metadataId/data',
      name: 'myCompanyUserTransactionMetadataDatas',
      component: () => import('@/views/mycompanies/users/transactions/metadata/data/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support'],
      },
    },
  ],
});
